/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/**
 * copyFrom的创建模式
 */
export enum CreateStyleE {
    All = 'all',
    New = 'new',
    CopyFrom = 'copyFrom'
}

/**
 * 共享类型
 *
 * 0： 普通共享
 *
 * 1：homedir
 *
 * 2：全部 - 用于过滤时下发
 */
export enum ShareTypeE {
    Homedir = '1',
    Normal = '0',
    All = '2'
}
